import { render, staticRenderFns } from "./MNavigationDrawer.vue?vue&type=template&id=5d1a51c8&scoped=true"
import script from "./MNavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./MNavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./MNavigationDrawer.vue?vue&type=style&index=0&id=5d1a51c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a51c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MAppAccount: require('/codebuild/output/src2377290956/src/app/components/molecules/MAppAccount.vue').default,AMenuItem: require('/codebuild/output/src2377290956/src/app/components/atoms/Menu/AMenuItem.vue').default,AMenuSubItem: require('/codebuild/output/src2377290956/src/app/components/atoms/Menu/AMenuSubItem.vue').default})
